// @flow
import actions from "./actions";
import {StopEnum as StopTypeEnum} from "../../../Utils/AppUtils";
import BackendOperations from "../../Middleware/Backend/operations";
import type {Dispatch} from "redux";
import type {GetState} from "../../Store";
import {getManualSelectionPolygonIfManualSelection} from "../CurrentRequest/utils";
import AppOperations from "../App/operations";
import selectors from "./selectors";
import type {TokenData} from "./reducers";
import isObjectLike from "lodash/isObjectLike";
import isString from "lodash/isString";
import {strings} from "../../../config";

const updateRequestData = (tokenData: TokenData) => {
    return (dispatch: Dispatch, getState: GetState) => {
        if (isObjectLike(tokenData)) {
            return dispatch(actions.updateRequestData(tokenData));
        } else {
            return dispatch(failTokenDecrypt(tokenData.toString()));
        }
    };
};

const getOriginTerminalsIfForced = () => {
    return (dispatch: Dispatch, getState: GetState) => {
        const state = getState();
        if (selectors.isOriginForcePolygon(state)) {
            const airportPolygon = getManualSelectionPolygonIfManualSelection(state);
            if (airportPolygon) {
                return dispatch(BackendOperations.doGetPolygonStops(airportPolygon.id, StopTypeEnum.PICKUP));
            }
        }
        return dispatch(AppOperations.noOperation());
    };
};

const getDestTerminalsIfForced = () => {
    return (dispatch: Dispatch, getState: GetState) => {
        const state = getState();
        if (selectors.isDestForcePolygon(state)) {
            const airportPolygon = getManualSelectionPolygonIfManualSelection(state);
            if (airportPolygon) {
                return dispatch(BackendOperations.doGetPolygonStops(airportPolygon.id, StopTypeEnum.DROPOFF));
            }
        }
        return dispatch(AppOperations.noOperation());
    };
};

const failTokenDecrypt = (error: ?string) => {
    return (dispatch: Dispatch, getState: GetState) => {
        return dispatch(actions.failTokenDecrypt(error && isString(error) ? error : strings.alert_message_technical_issue_text));
    };
};

export default {
    updateRequestData,
    getOriginTerminalsIfForced,
    getDestTerminalsIfForced,
    failTokenDecrypt,
};



// WEBPACK FOOTER //
// ./src/Store/Ducks/TokenData/operations.js